import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import Icons from '../../enums/icons.enum';
import { ErrorDialogService } from '../../services/error-dialog.service';
import { DialogModeType } from '../error/dialog-message-type.enum';

@Component({
    selector: 'fss-portal-info-snack-bar',
    templateUrl: './toast-message.component.html',
    styleUrls: ['./toast-message.component.scss'],
    standalone: false
})
export class ToastMessageComponent {
  public icons = Icons;
  public message: string;
  public linkUrl: any;
  public linkTarget = '_blank';
  public mode: DialogModeType;
  public action: string;
  public additionalDetails: any;

  constructor(
      private ref: MatSnackBarRef<ToastMessageComponent>,
      @Inject(MAT_SNACK_BAR_DATA) public data: {
        mode: DialogModeType,
        message: string,
        action: string,
        linkUrl?: string,
        additionalDetails?: any
      },
      private errorDialogSrv: ErrorDialogService) {

    this.mode = this.data.mode;
    this.message = this.data.message;
    this.action = this.data.action;
    this.linkUrl = this.data.linkUrl;
    this.additionalDetails = this.data.additionalDetails;

  }

  public dismiss(): void {
    this.ref.dismiss();
  }

  get isError(): boolean {
    return DialogModeType.ERROR === this.mode;
  }

  get hasAction(): boolean {
    return !!this.action;
  }

  get hasLink(): boolean {
    return !!this.linkUrl;
  }

  get hasAdditionalInfo(): boolean {
    return !!this.additionalDetails;
  }
  get getLinkMessage(): string {    
    return this.linkUrl.title;
  }

  get messageUrl(): string {
    return this.linkUrl.url;
  }

  public showAdditionalInfoDialog(error?: string): void {
    this.errorDialogSrv.open(this.mode, this.message, undefined, this.additionalDetails, error );
    this.dismiss();
  }
}
